module.exports = __webpack_public_path__ + "static/Home-BountyContest-326ba63bc8684aede2c44b30593df8d5.png";